import React, {Component} from 'react';
import {Button, DatePicker, Descriptions, Empty, Modal, Select, Table} from "antd";
import consts from "../consts";
import utils from "../common/utils";
import {Translation} from "react-i18next";
import "antd/dist/antd.css";
import LoadingComponent from "./common/LoadingComponent";

const {Option} = Select;
const {RangePicker} = DatePicker;

const DEPOSIT_TAB = 0
const WITHDRAW_TAB = 1
const dateFormat = 'DD/MM/YYYY';


class OpenOrderComponent extends LoadingComponent {
  columns = (t) => [
    {
      align: "center",
      title: t('user.open_order.id'),
      width: 80,
      dataIndex: 'id',
      fixed: 'left',
    },
    {
      align: "center",
      title: t('user.open_order.transfer'),
      width: 80,
      dataIndex: 'trade_type',
      key: 'trade_type',
      fixed: 'left',
      render: (trade_type) => <div
        style={{color: (trade_type === consts.ORDER_TRADE_TYPE_BUY) ? 'green' : 'red'}}>{t(trade_type === consts.ORDER_TRADE_TYPE_BUY ? 'Buy' : 'Sell')}</div>
    },
    {
      align: "center",
      title: t('user.open_order.order_type'),
      width: 80,
      dataIndex: 'order_type',
      key: 'order_type',
      render: (order_type) => <div>
        {window.$t(order_type)}
      </div>
    },
    {
      align: "center",
      title: t('user.open_order.pair'),
      width: 80,
      dataIndex: 'pair',
      key: 'pair',
    },
    {
      title: t('user.open_order.withdrawal'),
      width: 120,
      dataIndex: 'price',
      key: 'price',
      align: "center",
      ellipsis: true,
      render: (price, { currency }) => `${utils.formatCurrency(price)} ${currency}`
    },
    {
      title: t('user.open_order.coin'),
      width: 120,
      dataIndex: 'quantity',
      key: 'quantity',
      align: "center",
      ellipsis: true,
      render: (quantity, { coin }) => `${utils.formatCurrency(quantity)} ${coin}`
    },
    {
      align: "center",
      title: t('user.open_order.total'),
      width: 120,
      dataIndex: 'total',
      key: 'total',
      ellipsis: true,
      render: (total, { currency }) => `${utils.formatCurrency(total)} ${currency}`
    },
    {
      align: "center",
      title: t('user.open_order.all'),
      width: 100,
      dataIndex: 'filled',
      key: 'filled',
    },
    {
      align: "center",
      title: t('user.open_order.status'),
      width: 110,
      dataIndex: 'status',
      key: 'status',
      render: (status) => t(utils.parseOrderStatus(status)),
    },
    {
      align: "center",
      title: t('user.open_order.pending'),
      width: 145,
      dataIndex: 'updated_at',
      key: 'updated_at',
      render: (updated_at) => utils.formatTimeFromUnix(updated_at, "DD/MM/YYYY HH:mm:ss")
    },
    {
      align: "center",
      title: t('user.open_order.action'),
      dataIndex: 'id',
      fixed: 'right',
      width: 90,
      render: (id) => <div><Button type="default" onClick={(event) => {
        event.stopPropagation();
        this.handleCancelOrder(id)
      }}>
        {t('cancel_order')}</Button>
      </div>
    }
  ];
  
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      currentPage: 1,
      orderType: -1,
      tradeType: -1,
      market: '',
    };
    this.hideModal = this.hideModal.bind(this);
    this.handleCancelOrder = this.handleCancelOrder.bind(this);
  }
  
  componentDidMount() {
    this.fetchOpenOrder();
  }
  
  fetchOpenOrder = (pos = 0, count = consts.DEFAULT_PAGE_SIZE) => {
    this.enLoading()
    let [coin, currency] = this.state.market.split('/');
    this.props.onFetchOpenOrdersPaginateAction({
      pos,
      count,
      order_type: parseInt(this.state.orderType),
      trade_type: parseInt(this.state.tradeType),
      coin: coin || '',
      currency: currency || '',
    }, () => {
      this.unLoading()
    });
  }
  
  handleCancelOrder(order_id) {
    this.props.onCancelOrderAction({order_id}, () => this.setState({
      currentPage: 1,
      visible: false
    }));
  }
  
  hideModal() {
    this.setState({visible: false});
  }
  
  changeOrderType = (orderType) => {
    this.setState({orderType, currentPage: 1}, () => this.fetchOpenOrder());
  }
  
  changeTradeType = (tradeType) => {
    this.setState({tradeType, currentPage: 1}, () => this.fetchOpenOrder());
  }
  
  changeMarket = (market) => {
    this.setState({market, currentPage: 1}, () => this.fetchOpenOrder());
  }
  
  render() {
    return (
      <Translation>
        {(t) => <div className="depositandwithdrawal user-wallet">
          <div className="depositandwithdrawal-top">
            <div className='coin-container'>
              <div className='control'>
                <span className='label'> {t('user.open_order.transfer')} </span>
                <Select defaultValue="-1" className='coinSelect' onChange={this.changeTradeType}>
                  <Option value="-1"> {t('user.deposit_and_withdrawal.all')} </Option>
                  <Option value="0">{t('user.open_order.buy')} </Option>
                  <Option value="1"> {t("user.open_order.sell")} </Option>
                </Select>
              </div>
              <div className='control'>
                <span className='label'> {t('user.open_order.order_type')} </span>
                <Select defaultValue="-1" className='coinSelect' onChange={this.changeOrderType}>
                  <Option value="-1"> {t('user.deposit_and_withdrawal.all')} </Option>
                  <Option value="0"> {t('user.open_order.limit')} </Option>
                  <Option value="1"> {t('user.open_order.market')} </Option>
                  <Option value="2"> {t('user.open_order.stop_limit')}</Option>
                </Select>
              </div>
              
              
              <div className='control'>
                <span className='label'> {t('user.open_order.pair')} </span>
                <Select defaultValue="" className='coinSelect pair' onChange={this.changeMarket}>
                  <Option value=""> {t('user.deposit_and_withdrawal.all')} </Option>
                  {window._.map((this.props.setting?.coinSettings || []), (item) => {
                    return <Option key={item.pair}>
                      <div className="ln-big">
                        {item.pair}
                      </div>
                    </Option>
                  })}
                </Select>
              </div>
            </div>
          </div>
          
          <div className='depositandwithdrawal-top'>
            {/*todo put in class*/}
            <div style={{ marginBottom: '10px', textAlign: 'right'}}>
              <Button type="default" onClick={(event) => {
                this.props.order.openOrders.length > 0 ? this.props.onCancelAllOrder() : utils.showNotification(window.$t('common.notification'), window.$t('model.cancel_order_null'))
              }}>
                {t('user.open_order.cancel_all')}</Button>
            </div>

            <Table columns={this.columns(t)}
                   rowClassName="pointer"
                   scroll={{ x: 1400 }}
                   locale={{
                     emptyText: (<Empty description={<span className="bold">{window.$t('common.empty')}</span>}/>)
                   }}
                   pagination={{
                    showQuickJumper: true,
                     current: this.state.currentPage,
                     onChange: (page, pageSize) => {
                       this.fetchOpenOrder((page - 1) * pageSize, pageSize)
                       this.setState({currentPage: page});
                     },
                     defaultPageSize: 10,
                     total: this.props.order.totalCountOpenOrder,
                     hideOnSinglePage: true,
                     // showSizeChanger: true,
                     // showSizeChanger: true,
                     // pageSizeOptions: [1, 5, 10, 25, 50],
                   }}
                   dataSource={[...this.props.order.openOrders || []]}
                   loading={this.state.isLoading}
                   className="mb-large"
            />
          </div>
          
          {/*<Modal*/}
          {/*  title={t('user.open_order_exchange.title_modal', {pair: this.state.orderPopup?.pair})}*/}
          {/*  visible={this.state.visible}*/}
          {/*  onOk={this.handleCancelOrder}*/}
          {/*  onCancel={this.hideModal}*/}
          {/*  okText={}*/}
          {/*  cancelText={'Đóng'}*/}
          {/*>*/}
          {/*  <div className="fz-medium">*/}
          {/*    <Descriptions title={t('user.open_order_exchange.infor_cancel')}>*/}
          {/*      <Descriptions.Item*/}
          {/*        label={t('user.open_order_exchange.deposits')}>{`${this.state.orderPopup?.pair}`}</Descriptions.Item>*/}
          {/*      <Descriptions.Item label={t('user.open_order.order_type')}>*/}
          {/*        {window.$t(utils.parseOrderType(this.state.orderPopup?.type))}*/}
          {/*      </Descriptions.Item>*/}
          {/*      <Descriptions.Item*/}
          {/*        label={t('user.open_order_exchange.order_state')}>*/}
          {/*          {window.$t(utils.parseOrderStatus(this.state.orderPopup?.status))}*/}
          {/*          </Descriptions.Item>*/}
          {/*      <Descriptions.Item*/}
          {/*        label={t('user.open_order_exchange.withdrawal')}>{`${this.state.orderPopup?.price} ${this.state.orderPopup?.coin}`}</Descriptions.Item>*/}
          {/*      <Descriptions.Item*/}
          {/*        label={t('user.open_order_exchange.total')}>{`${this.state.orderPopup?.total} ${this.state.orderPopup?.currency}`}</Descriptions.Item>*/}
          {/*      <Descriptions.Item*/}
          {/*        label={t('user.open_order_exchange.matching_amount')}>{`${this.state.orderPopup?.executed_quantity} ${this.state.orderPopup?.coin}`}</Descriptions.Item>*/}
          {/*      <Descriptions.Item*/}
          {/*        label={t('user.open_order_exchange.rest_amount')}>{`${this.state.orderPopup?.quantity} ${this.state.orderPopup?.coin}`}</Descriptions.Item>*/}
          {/*      <Descriptions.Item*/}
          {/*        label={t('user.open_order_exchange.total_amount_order')}>{`${this.state.orderPopup?.quantity + this.state.orderPopup?.executed_quantity} ${this.state.orderPopup?.coin}`}</Descriptions.Item>*/}
          {/*      <Descriptions.Item label={t('user.open_order_exchange.matched_percent')}>*/}
          {/*        {this.state.orderPopup?.filled}*/}
          {/*      </Descriptions.Item>*/}
          {/*    </Descriptions>,*/}
          {/*  </div>*/}
          {/*</Modal>*/}
        </div>}
      </Translation>
    );
  }
}

export default OpenOrderComponent;
